import React from "react";
import style from "../../styles/buynow.module.scss";
import { useNavigate } from "react-router-dom";
import { useCart } from "react-use-cart";
import { trackAddToCart } from "../../utils/tracking";
import { RiMoneyEuroCircleLine } from "react-icons/ri";

const BuyNow = ({ product, quantity }) => {
  const { addItem } = useCart();
  const navigate = useNavigate();
  const addToCart = (product) => {
    addItem(product, quantity);
    navigate("/cart");
    trackAddToCart(product, quantity);
  };

  return (
    <button
      className={style.button}
      onClick={() => {
        addToCart(product);
      }}
    >
      <RiMoneyEuroCircleLine size={30} />
      Blej Tani
    </button>
  );
};

export default BuyNow;
